/**
 * The deployed build's id (the commit SHA on Vercel).
 *
 * REG-963: the id lives in index.html (<meta name="app-build-id">) and in
 * /version.json, never inside a JS module. A value compiled into the entry
 * bundle changes the entry's hash on every deploy, and through the imports
 * every lazy chunk's hash with it. Tabs opened before a deploy then asked for
 * chunk names that no longer exist, so every deploy broke lazy routes
 * (Opportunities, dashboards) in every open tab. With the id out of the
 * bundle, a chunk keeps its name until its own code changes.
 *
 * The meta tag and version.json are written by the app-build-id plugin in
 * vite.config.ts.
 */

export const BUILD_ID_META_NAME = 'app-build-id';
export const VERSION_JSON_PATH = '/version.json';

let cachedBuildId: string | null = null;

export function getBuildId(): string {
  if (cachedBuildId !== null) return cachedBuildId;
  const meta = typeof document === 'undefined'
    ? null
    : document.querySelector<HTMLMetaElement>(`meta[name="${BUILD_ID_META_NAME}"]`);
  cachedBuildId = meta?.content || 'dev';
  return cachedBuildId;
}
